var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    { ref: "modal", attrs: { heading: "Background Verification Permission" } },
    [
      _c("div", { staticClass: "mb-4" }, [
        _c("h5", [
          _vm._v(
            "The candidate has not completed their iFacts form. Please ask the candidate to complete the form, or upload it manually."
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x align-right" }, [
        _c("div", { staticClass: "cell shrink" }, [
          _c(
            "button",
            {
              staticClass: "button warning",
              attrs: { type: "button" },
              on: { click: _vm.toggleModal }
            },
            [_vm._v("Close")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b30f96a", { render: render, staticRenderFns: staticRenderFns })
  }
}